<template>
  <a href="https://www.struck-lichtwerbung.de" class="header-logo" :class="{ 'logo-glowing': logoGlowIntensity > 0.1 }" :style="logoGlowStyle" rel="external noopener" target="_blank" :title="$t('vue.components.header.title')">
    <img :src="struckLogo" alt="Struck-Leuchten ST-Service" fetchpriority="high">
  </a>
</template>

<script>
import struckLogo from '@assets/images/struck-logo.svg'

export default {
  name: 'header-logo',

  data() {
    return {
      struckLogo,
      isLit: false
    }
  },

  created() {
    this.isLit = this.calculateIsLit()
    this.scheduleNextToggle()
  },

  beforeUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  },

  methods: {
    // Approximate sunrise/sunset for Germany (~51°N latitude)
    getSunTimes(date) {
      const startOfYear = new Date(date.getFullYear(), 0, 0)
      const dayOfYear = Math.floor((date - startOfYear) / (1000 * 60 * 60 * 24))

      // Cosine peaks at winter solstice (day 355/0)
      const dayAngle = ((dayOfYear + 10) / 365) * 2 * Math.PI
      const seasonFactor = Math.cos(dayAngle)

      // Sunrise: 5:00 (summer) to 8:15 (winter)
      const sunriseHour = 6.625 + seasonFactor * 1.625
      // Sunset: 21:30 (summer) to 16:15 (winter)
      const sunsetHour = 18.875 - seasonFactor * 2.625

      const sunrise = new Date(date)
      sunrise.setHours(Math.floor(sunriseHour), (sunriseHour % 1) * 60, 0, 0)

      const sunset = new Date(date)
      sunset.setHours(Math.floor(sunsetHour), (sunsetHour % 1) * 60, 0, 0)

      return { sunrise, sunset }
    },

    calculateIsLit() {
      const now = new Date()
      const { sunrise, sunset } = this.getSunTimes(now)
      return now >= sunset || now < sunrise
    },

    scheduleNextToggle() {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      const now = new Date()
      const { sunrise, sunset } = this.getSunTimes(now)

      let nextToggle
      if (now < sunrise) {
        nextToggle = sunrise
      } else if (now < sunset) {
        nextToggle = sunset
      } else {
        // After sunset, next toggle is tomorrow's sunrise
        const tomorrow = new Date(now)
        tomorrow.setDate(tomorrow.getDate() + 1)
        nextToggle = this.getSunTimes(tomorrow).sunrise
      }

      const delay = nextToggle - now
      this.timeout = setTimeout(() => {
        this.isLit = this.calculateIsLit()
        this.scheduleNextToggle()
      }, delay)
    }
  },

  computed: {
    logoGlowIntensity() {
      return this.isLit ? 1.0 : 0
    },

    logoGlowStyle() {
      return {
        '--logo-lit': this.isLit ? 1 : 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use "variables";

.header-logo {
  float: left;
  background: variables.$logo-background-color;
  margin-right: variables.$container-padding;

  img {
    width: variables.$logo-width-small;
    height: variables.$logo-height-small;
    padding: 10px;
    transition: filter 0.5s ease-in-out;

    @media screen and (min-width: variables.$screen-sm) {
      width: variables.$logo-width;
      height: variables.$logo-height;
      padding: 15px;
    }
  }

  // Bloom effect: stacked drop-shadows + brightness
  &.logo-glowing img {
    filter:
      // Brightness boost - makes white letters appear to emit light
      brightness(1.15)
      // Tight core glow
      drop-shadow(0 0 2px rgba(255, 255, 255, 0.9))
      // Medium glow
      drop-shadow(0 0 8px rgba(255, 250, 230, 0.6))
      // Large diffuse glow
      drop-shadow(0 0 20px rgba(255, 245, 200, 0.4));
  }
}
</style>
